// ** React Imports
import { matchPath } from "react-router-dom";

// ** Redux
import { useDispatch, useSelector } from "react-redux";
import { getGallery } from "store/modules/main-pages/galleries/get-gallery.action";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import loadable from "@loadable/component";

// ** Custom Components
import Block from "components/layout/Block";
import Nav from "components/layout/Nav";
import NavItemLink from "components/base/NavItemLink";
const GalleryViewTypeSelector = loadable(
	() => import("../GalleryViewTypeSelector"),
	{
		ssr: false,
	}
);

// #####################################################

const GalleryNavPanel = ({ viewType, handleViewType, galleriesKey }) => {
	const { t } = useTranslation("common", "filtersAndSelectors");

	const dispatch = useDispatch();

	const isClient = useSelector((state) => state.globalCommon.isClient);
	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	const handleGetGallery = (siteName) => {
		dispatch(getGallery({ siteName }));
	};

	// #####################################################

	return (
		<Block flex full justifyBetween alignEnd mt={1}>
			<Nav.Panel appearance="tabs" noMargin withMarginRight>
				<Nav.List>
					<NavItemLink
						container={Nav.Item}
						to="/galleries"
						key="gallery"
						isActive={(_, location) => {
							return matchPath(location.pathname, {
								path: "/galleries",
								exact: true,
							});
						}}
						onClick={() => handleGetGallery("galleriesAll")}
					>
						<Nav.Item.Content>
							{t(`common:selectAll2`)}
						</Nav.Item.Content>
					</NavItemLink>
					<NavItemLink
						container={Nav.Item}
						to="/galleries/photos"
						key="photos"
						onClick={() => handleGetGallery("galleriesPhotos")}
					>
						<Nav.Item.Content>{t(`pages:images`)}</Nav.Item.Content>
					</NavItemLink>
					<NavItemLink
						container={Nav.Item}
						to="/galleries/videos"
						key="videos"
						onClick={() => handleGetGallery("galleriesVideos")}
					>
						<Nav.Item.Content>{t(`pages:videos`)}</Nav.Item.Content>
					</NavItemLink>
				</Nav.List>
			</Nav.Panel>
			<Block mb={3}>
				{isClient && isAuth && (
					<GalleryViewTypeSelector
						viewType={viewType}
						handleViewType={handleViewType}
						galleriesKey={galleriesKey}
					/>
				)}
			</Block>
		</Block>
	);
};

// #####################################################

export default GalleryNavPanel;

// #####################################################
